import React, { useRef, useEffect, useState } from "react";
import { Card, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import {
    getDropdowns,
    initialFilter,
    sapendpoint,
    createReqObj,
    actionType,
    findLabelByValue
} from "../constants";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import APopover from "views/pages/manage/common/a-popover";
import FilterForm from "../FilterForm";
import { getFilterCount } from "../../../mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { fetchAllPostPromisedData, generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import PrListing from "./PrListing";
import ListComponent from "../ListComponent";
import Header from "../Header";
import ALoader from "views/pages/manage/common/a-loader";
import MessageDialog from "../MessageDialog";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import styles from "../styles.module.scss";
import CustomUpload from "../CustomUpload";

const SapPurchaseOrderListing = () => {
    const history = useHistory();
    const [isLoading, setLoading] = useState(false);
    const [dropdownData, setDropdownData] = useState([]);
    const [globalFilter, setGlobalFilter] = useState({ ...initialFilter });
    const [filterCount, setFilterCount] = useState(getFilterCount({ ...globalFilter }));
    const [prData, setPrData] = useState([])
    const [open, setOpen] = useState(false)
    const [rows, setRows] = useState([])
    const [headerData, setHeaderData] = useState()
    const [prWarningData, setPRwarningData] = useState();
    const [purchaseType, setPurchaseType] = useState(null);
    const [errorResponse, setErrorResponse] = useState(null);
    const [isUpdate, setIsUpdate] = useState(false);
    const [fileData, setFileData] = useState({});

    const ref = useRef();

    useEffect(() => {
        init()
    }, []);

    const init = async () => {
        try {
            setLoading(true);
            const dropdown = await getDropdowns();
            setDropdownData(dropdown);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const filterFormHandler = (key, value) => {
        // used for managing filter form state
        setGlobalFilter((prev) => ({ ...prev, [key]: value ?? [] }));
    };

    const searchInputHandler = (inputValue) => {
        setGlobalFilter({ PrNo: inputValue })
        searchHandler({ PrNo: inputValue })
        setFilterCount(0)
    }

    const crossHandler = () => {
        setGlobalFilter((prev) => ({ ...prev, PrNo: '' }));
        setRows({});
        // searchHandler({})
    }

    const searchPrHandler = (PrNo) => {
        searchHandler({ PrNo })
        setOpen(false)
    }

    const searchHandler = async (reqObj) => {
        let url = sapendpoint?.search;
        let method = "post";
        setLoading(true)
        try {
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code == 200) {
                if (!reqObj?.PrNo && reqObj?.Plant && reqObj?.DateHigh && reqObj?.DateLow) {
                    if (!resp?.data?.PRs?.[0]?.Item || (resp?.data?.PRs?.[0]?.Item).length < 1) {
                        setPRwarningData("No PR found")
                    }
                    else {
                        setPRwarningData("");
                        setPrData(resp?.data?.PRs?.[0]?.Item);
                    }
                    setOpen(true);
                }
                else {
                    let contactDetails = { Telephone_no: "", Department: "", Email_id: "" };

                    let res = resp?.data?.PRs?.[0]?.Item ? (resp?.data?.PRs?.[0]?.Item).map((item, index) => {
                        contactDetails = {
                            Telephone_no: item?.Telephone_no ?? contactDetails.Telephone_no,
                            Department: { label: findLabelByValue(item?.Department, 'Department' ?? (item?.Department ?? contactDetails.Department)), value: item?.Department ?? contactDetails.Department },
                            Email_id: item?.Email_id ?? contactDetails.Email_id,
                        };

                        return {
                            ...item,
                            id: index,
                            Material_no: { label: `${item?.Material_no} | ${item?.Material_text}`, value: item?.Material_no },
                            Plant: { label: item?.Plant, value: item?.Plant },
                            Item_cat: { label: findLabelByValue(item?.Item_cat, 'Item_cat') ?? item?.Item_cat, value: item?.Item_cat },
                            Account_asignment: { label: findLabelByValue(item?.Account_asignment, 'Account_asignment') ?? item?.Account_asignment, value: item?.Account_asignment },
                            Purchase_group: { label: findLabelByValue(item?.Purchase_group, 'Purchase_group') ?? item?.Purchase_group, value: item?.Purchase_group },
                            Department: { label: findLabelByValue(item?.Department, 'Department') ?? item?.Department, value: item?.Department },
                            Asset_no: { label: item?.Asset_text, value: item?.Asset_no },
                            Vendor: { label: item?.Vendor_text, value: item?.Vendor },
                            Cost_Center: {
                                label: item?.Cost_Center ? `${item?.Cost_Center ?? ''} | ${item?.CostCntr_text ?? ''}` : '',
                                value: item?.Cost_Center
                            },
                            // nested item
                            Service_Item: item?.Service_Item?.map((service, serviceIndex) => ({
                                ...service,
                                id: serviceIndex,
                                Service_no: { label: `${service?.Service_no} | ${service?.Short_text}`, value: service?.Service_no },
                                Cost_Center: { label: service?.CostCntr_text, value: service?.Cost_Center },
                            })) || [],
                            //release strategy Params
                            Release_details: item?.Release_details?.map((stategy, rIndex) => ({
                                ...stategy,
                                id: rIndex,
                            })) || [],
                        }
                    }) : [];

                    let headerRes = resp?.data?.PRs?.[0]?.Header
                        ? {
                            ...resp?.data?.PRs?.[0]?.Header,
                            Campaign_Name: { label: findLabelByValue(resp?.data?.PRs?.[0]?.Header?.Campaign_Name, 'Campaign_Name') ?? resp?.data?.PRs?.[0]?.Header?.Campaign_Name, value: resp?.data?.PRs?.[0]?.Header?.Campaign_Name },
                            Doc_Type: { label: findLabelByValue(resp?.data?.PRs?.[0]?.Header?.Doc_Type, 'Doc_Type') ?? resp?.data?.PRs?.[0]?.Header?.Doc_Type, value: resp?.data?.PRs?.[0]?.Header?.Doc_Type },
                            ...contactDetails,
                        }
                        : {};

                    // If pr no is present then also store this in state
                    if (reqObj?.PrNo && reqObj?.PrNo.trim() !== "") {
                        setPrData([{ clickedRow: reqObj?.PrNo }]);
                        setGlobalFilter((prev) => ({ ...prev, PrNo: reqObj?.PrNo }));
                    }

                    setPurchaseType(resp?.data?.PRs?.[0]?.Header?.Type);
                    setHeaderData(headerRes);
                    setRows(res);
                }
            }
        }
        catch (err) {
            console.log(err);
        }
        finally {
            setLoading(false);
        }
    }

    const createUpdateHandler = async (rowForm) => {
        try {
            // Find the index of the row that matches the given rowForm.id
            const rowIndex = rows?.findIndex((row) => row.id === rowForm.id);

            if (rowIndex !== -1) {
                // Update the existing row based on id
                const updatedRows = [...rows];
                updatedRows[rowIndex] = { ...rowForm, isNew: false };
                setRows(updatedRows);
                ref.current.stopEditing();
                setIsUpdate(true);
            }
        } catch (err) {
            console.error(err);
        }
    };

    /**
    * same function to delete single line item or single service item 
    */
    const deleteItemHandler = (id, undelete = false) => {
        try {
            const rowIndex = rows?.findIndex((row) => row.id === id);

            if (rowIndex !== -1) {
                const updatedRows = [...rows];
                updatedRows[rowIndex] = {
                    ...updatedRows[rowIndex],
                    isNew: false,
                    Delete_ind: !undelete ? 'X' : ""
                };
                setRows(updatedRows);
                setIsUpdate(true);
            }
        } catch (err) {
            console.error(err);
        }
    };


    const saveAllPrItems = async (req) => {
        try {
            setLoading(true);
            let url = sapendpoint?.create;
            let method = 'post';
            setIsUpdate(true);
            const reqObj = createReqObj(headerData, req, purchaseType, actionType[1], prData[0]?.clickedRow, fileData);
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code == 200) {
                // if (!resp?.data?.mt_pr_res?.isError) {
                //     setFileData({});
                //     setHeaderData([]); 
                // }
                const returnData = resp?.data?.mt_pr_res?.Return;
                if (returnData?.length) {
                    if (resp?.data?.mt_pr_res?.isError == "false") {
                        searchPrHandler(prData[0]?.clickedRow);
                    }
                    setErrorResponse((prev) => (
                        {
                            ...prev,
                            isCopy: resp?.data?.mt_pr_res?.PR_no ? true : false,
                            PR_no: resp?.data?.mt_pr_res?.PR_no,
                            list: returnData?.map((error, index) => ({
                                id: generateRandomId() + index,
                                ...error,
                            }))
                        }
                    ))
                }

                console.log("error res", errorResponse);
            }
        } catch (err) {
            console.log(err);
        } finally {
            ref.current.stopEditing();
            setLoading(false);
        }
    };

    return (
        <>
            <Card className="mx-2">
                <div className="d-flex my-3 mx-2 gap-lg">
                    <div className="d-flex justify-content-between">
                        <BackArrow
                            className="color-black mr-2 cursor"
                            onClick={() => history.goBack()}
                        />
                        <h4 className="color-black ml-2 mb-0">SAP Purchase Listing</h4>
                    </div>
                    <div className="d-flex justify-content-between ml-auto" >
                        <div style={{ width: "fit-content" }}>
                            <AInput
                                style={{ width: '320px', height: '30px' }}
                                value={globalFilter?.PrNo}
                                handler={(value) => {
                                    setGlobalFilter((prev) => ({ ...initialFilter, ['PrNo']: value }))
                                }}
                                crossIcon={true}
                                rightSearchIcon={true}
                                searchIconClickHandler={() => {
                                    searchInputHandler(globalFilter?.PrNo);
                                }}
                                crossHandler={crossHandler}

                            />
                        </div>

                        <APopover
                            buttonComponent={(onClick, styles) => (
                                <AButton
                                    className="tiny-semi-bold color-dark"
                                    onClick={onClick}
                                    updatedStyle={{
                                        minWidth: "61px",
                                        ...(filterCount > 0
                                            ? {
                                                border: "1px solid #00B0F5",
                                                color: "#00B0F5",
                                            }
                                            : styles),
                                    }}
                                >
                                    Filter {filterCount > 0 && <>( {filterCount} )</>}
                                </AButton>
                            )}
                            menuComponent={(closePopup) => (
                                <FilterForm
                                    closePopup={closePopup}
                                    dropdownData={dropdownData}
                                    globalFilter={globalFilter}
                                    setGlobalFilter={setGlobalFilter}
                                    filterCount={filterCount}
                                    setFilterCount={setFilterCount}
                                    searchHandler={searchHandler}
                                    setRows={setRows}
                                />
                            )}
                        />
                    </div>
                </div>

                {isLoading && <ALoader position='fixed' />}
                {headerData && <div className="mx-2" style={{ boxShadow: ' 10px 10px 5px white' }}>
                    <Row>
                        <div className="d-flex my-3" style={{ padding: "0 10px", width: '100%' }}>
                            <Header headerData={headerData} setHeaderData={setHeaderData} listing={true} purchaseType={purchaseType} />
                        </div>
                    </Row >
                </div>}

                <ListComponent
                    rows={rows}
                    ref={ref}
                    loading={isLoading}
                    setLoading={setLoading}
                    currentPage={0}
                    //   totalRecords={paginationInfo.totalRecords}
                    //   pageChangeHandler={pageChangeHandler}
                    createUpdateHandler={createUpdateHandler}
                    dropdownData={dropdownData}
                    purchaseReqType={purchaseType}
                    //   updatePurchaseOrder={updatePurchaseOrder}
                    listing={true}
                    deleteItemHandler={deleteItemHandler}
                    headerData={headerData}
                />

                {isUpdate && (
                    <>
                        <div className={`${styles["upload-btn-style"]}`}>
                            <CustomUpload
                                fileData={fileData}
                                setFileData={setFileData}
                                id={"sap-file"}
                            />
                        </div>

                        <div className="d-flex justify-content-start mt-4 mb-4">
                            <AButton
                                variant="primary_filled"
                                onClick={() => { saveAllPrItems(rows) }}
                                size="xs"
                            // disabled={
                            //     !headerData?.Text ||
                            //     !headerData?.Doc_Type ||
                            //     purchaseOrder[purchaseType?.value]?.length === 0
                            // }
                            >
                                Save All
                            </AButton>
                        </div>
                    </>
                )}

                {errorResponse && !isLoading && (
                    <MessageDialog
                        rows={errorResponse?.list}
                        PR_no={errorResponse?.PR_no}
                        setErrorResponse={setErrorResponse}
                        loading={isLoading}
                        msgLabelKey={"Message_text"}
                        errorKey={"Message_code"}
                        showClipboard={errorResponse?.isCopy}
                    />
                )}
            </Card>
            <PrListing open={open} setOpen={setOpen} rows={prData} searchPrHandler={searchPrHandler} prWarningData={prWarningData} />
        </>
    )
}
export default SapPurchaseOrderListing;